import { createStandaloneToast } from "@chakra-ui/react";
import axios from "axios";
import dotenv from "dotenv";
// dotenv.config();

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API,
});

// Request interceptor: Attach token from localStorage
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);// Response interceptor: Handle 401 errors
const { toast } = createStandaloneToast();
axiosInstance.interceptors.response.use(
  (response) => response, // Pass through successful responses
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle 401 Unauthorized
      toast({
        title: "Session Expired",
        description: "Your session has expired. Please log in again.",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
      localStorage.removeItem("token");
      setTimeout(() => {
        window.location.href = "/login";
      }, 3000);
    }
    return Promise.reject(error);
  }
);




export default axiosInstance;
